import { Component } from "react";
import styled from "styled-components";
import { grid, borderRadius } from "../styles/constants";
import CandidateList from "../styles/list";
import Title from "../styles/title";
import { Candidate } from "../types";
import { t } from "../../../../translations/translation.service";

const Container = styled.div<{ backgroundColor?: string }>`
	margin: ${grid}px;
	background-color: #f5f5f5;
	border-radius: ${borderRadius}px;
`;

const Header = styled.div`
	display: flex;
	align-self: center;
	width: 100%;
	text-align: center;
`;

interface ColumnProps {
	title: string;
	candidates: Candidate[];
	isScrollable?: boolean;
	color?: string;
}

class Column extends Component<ColumnProps> {
	render() {
		const { title, candidates, isScrollable, color } = this.props;
		return (
			<Container ref={null} backgroundColor={title}>
				<Header>
					<Title step={title}>
					   {t(title)}
					</Title>
				</Header>
				<CandidateList
					listId={title}
					style={{
						backgroundColor: color,
					}}
					candidates={candidates}
					internalScroll={isScrollable}
					colors={title}
				/>
			</Container>
		);
	}
}

export default Column;
